<template>
  <b-card class="border-none">
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      id="edit-url"
      title="Edit URL"
      hide-footer
      header-text-variant="white"
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleUpdate)">
          <div class="mb-4">
            <p class="input-title text-black">Page</p>
            <base-input name="Page" :rules="{ required: true }">
              <b-form-select
                v-model="page"
                placeholder="Select Page"
                class="mr-4"
              >
                <b-form-select-option :value="null" selected disabled
                  >Select Page
                </b-form-select-option>
                <b-form-select-option
                  v-for="item in pageOptions"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.text }}
                </b-form-select-option>
              </b-form-select>
            </base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Category</p>
            <base-input name="Category" :rules="{ required: true }">
              <b-form-select
                v-model="category"
                placeholder="Select Category"
                class="mr-4"
              >
                <b-form-select-option :value="null" selected disabled
                  >Select Category
                </b-form-select-option>
                <b-form-select-option
                  v-for="item in options"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.text }}
                </b-form-select-option>
              </b-form-select>
            </base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Title</p>
            <base-input
              v-model="title"
              placeholder="Enter url title"
              class="md:border-0 lg:border-0 custipshadow"
              name="Title"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Link</p>
            <base-input
              v-model="link"
              placeholder="Enter link"
              class="md:border-0 lg:border-0 custipshadow"
              name="Link"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataload"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataload()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="affiliateUrlData"
      border
    >
      <el-table-column
        label="Page"
        min-width="110px"
        prop="page"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.page }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Category"
        min-width="210px"
        prop="category"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.category }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Title"
        min-width="220px"
        prop="title"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Link"
        min-width="250px"
        prop="link"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.link }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      search: "",
      totalPages: 0,
      title: "",
      link: "",
      category: "",
      options: [
        { value: "Latest Research", text: "Latest Research" },
        { value: "Explore Resources", text: "Explore Resources" },
        {
          value: "Helpful Links and Collaborations",
          text: "Helpful Links and Collaborations",
        },
      ],
      page: "",
      pageOptions: [
        { value: "Cancer", text: "Cancer" },
        { value: "Palliative Care", text: "Palliative Care" },
        { value: "Dementia", text: "Dementia" },
        { value: "Neurological Disorders", text: "Neurological Disorders" },
      ],
      urlId: "",
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.dataload();
        this.currentPage = 1;
      }, 500),
    },
  },
  methods: {
    async dataload() {
      let payload = {
        search: this.search,
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      let data = await this.$store.dispatch("affiliate/getUrl", payload);
      this.totalPages = data.data.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataload();
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.page = row.page;
      this.category = row.category;
      this.title = row.title;
      this.link = row.link;
      this.urlId = row._id;
      this.$bvModal.show("edit-url");
    },
    async handleUpdate() {
      let payload = {
        page: this.page,
        category: this.category,
        title: this.title.trim(),
        link: this.link.trim(),
        urlId: this.urlId,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/updateUrl", payload);
        this.dataload();
        this.$bvModal.hide("edit-url");
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      // console.log(row);
      const payload = { urlId: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/deleteUrl", payload);
        this.dataload();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("affiliate", {
      affiliateUrlData: "affiliateUrlData",
    }),
  },
  mounted() {
    this.dataload();
  },
};
</script>
